(function () {
  'use strict';

  var config = window.melitehVacancies || {};
  var currentSearchQuery = '';

  function getUrlParam(name) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
  }

  function getActiveIndustry() {
    return config.activeIndustry || getUrlParam('industry') || '';
  }

  function buildUrlWithParams(params) {
    return window.location.pathname + (params.toString() ? '?' + params.toString() : '');
  }

  function safeGtag() {
    if (typeof window.gtag === 'function') {
      window.gtag.apply(null, arguments);
    }
  }

  function applyFilters() {
    var jobCards = document.querySelectorAll('.job-card');
    var totalVacanciesCounter = document.getElementById('total-open-vacancies-counter');
    if (!totalVacanciesCounter) {
      return;
    }

    var dateFilter = (document.querySelector('input[name="maxPostedForDays"]:checked') || {}).value;

    var visibleCount = 0;

    jobCards.forEach(function (jobCard) {
      var jobDate = new Date(jobCard.dataset.date);
      var jobTitle = (jobCard.dataset.title || (jobCard.querySelector('.job-title') && jobCard.querySelector('.job-title').textContent) || '').toLowerCase();

      var matchesDate = true;
      if (dateFilter) {
        var cutoffDate = new Date();
        cutoffDate.setDate(cutoffDate.getDate() - parseInt(dateFilter, 10));
        matchesDate = jobDate >= cutoffDate;
      }

      var isOpenApplication = jobTitle.includes('open application');
      var matchesSearch =
        !currentSearchQuery ||
        jobTitle.includes(currentSearchQuery);

      var shouldDisplay =
        matchesDate &&
        matchesSearch &&
        !isOpenApplication;

      jobCard.style.display = shouldDisplay ? '' : 'none';
      if (shouldDisplay) {
        visibleCount++;
      }
    });

    totalVacanciesCounter.textContent = String(visibleCount);
    safeGtag('config', 'G-6NM1J03PQF', {
      page_path: window.location.pathname,
      transport_type: 'beacon',
    });
  }

  function handleSearch(event) {
    if (event && event.preventDefault) {
      event.preventDefault();
    }

    var searchInput = document.getElementById('job-search-input') || document.getElementById('jobs-text-search-input');
    if (!searchInput) {
      return;
    }

    var query = searchInput.value.trim().toLowerCase();
    currentSearchQuery = query;
    var activeIndustry = getActiveIndustry();

    if (!activeIndustry) {
      activeIndustry = 'All Jobs';
    }

    var newUrlParams = new URLSearchParams(window.location.search);
    if (query) {
      newUrlParams.set('query', query);
    } else {
      newUrlParams.delete('query');
    }

    newUrlParams.delete('industry');

    history.pushState({}, '', buildUrlWithParams(newUrlParams));

    applyFilters();
  }

  function setupSearch() {
    var searchInput = document.getElementById('job-search-input');
    var searchButton = document.getElementById('job-search-button');
    var searchForm = document.getElementById('job-search-form') || document.getElementById('job-text-search-form');

    if (searchInput) {
      searchInput.addEventListener('input', handleSearch);
      searchInput.addEventListener('keypress', function (event) {
        if (event.key === 'Enter') {
          handleSearch(event);
        }
      });
    }

    if (searchButton) {
      searchButton.addEventListener('click', handleSearch);
    }

    if (searchForm) {
      searchForm.addEventListener('submit', handleSearch);
    }

    var initialQuery = getUrlParam('query');
    if (initialQuery && searchInput) {
      searchInput.value = initialQuery;
      handleSearch(new Event('input'));
    }
  }

  function setupIndustryState(activeIndustry) {
    if (activeIndustry) {
      document.querySelectorAll('.industry-categories').forEach(function (link) {
        var title = link.querySelector('.pills-title');
        var industryName = title ? title.textContent.trim() : '';
        if (industryName === 'Information Technology') {
          industryName = 'IT';
        }
        if (industryName.toLowerCase() === activeIndustry.toLowerCase()) {
          link.classList.add('active');
        }
      });
    } else {
      document.querySelectorAll('.industry-categories').forEach(function (link) {
        var title = link.querySelector('.pills-title');
        if (title && title.textContent.trim() === 'All Jobs') {
          link.classList.add('active');
        }
      });
    }

    var industryNameElement = document.querySelector('.breadcrumbs-industry-name');
    if (industryNameElement && !document.querySelector('.vacancy-detail')) {
      industryNameElement.textContent = activeIndustry || 'All Jobs';
    }
  }

  function setupDepartmentFiltersToggle() {
    document.querySelectorAll('[data-department-filters]').forEach(function (filter) {
      var button = filter.querySelector('[data-department-filters-toggle]');
      if (!button) {
        return;
      }

      button.addEventListener('click', function () {
        var isExpanded = filter.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        button.textContent = isExpanded
          ? button.dataset.expandedLabel || 'Show fewer departments'
          : button.dataset.collapsedLabel || 'Show more departments';
      });
    });
  }

  async function subscribeToNews(event) {
    if (event && event.preventDefault) {
      event.preventDefault();
    }

    var form = event && event.target ? event.target : null;
    if (!form) {
      return;
    }

    var formData = new FormData(form);
    var input = form.elements ? form.elements['email'] : null;
    var button = form.querySelector('button');
    if (!input || !button) {
      return;
    }

    input.setAttribute('disabled', 'disabled');
    try {
      var response = await fetch('https://api.mhcaviation.com/subscribe-to-news', {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          email: formData.get('email'),
        }),
      });

      if (response.status !== 200) {
        throw new Error('unsuccessful server response: ' + response.statusText);
      }

      button.textContent = 'Subscribed';
      button.setAttribute('disabled', 'disabled');
    } catch (error) {
      input.removeAttribute('disabled');
      alert('Failed to subscribe: ' + (error && error.message ? error.message : String(error)));
    }
  }

  window.applyFilters = applyFilters;
  window.subscribeToNews = subscribeToNews;

  document.addEventListener('DOMContentLoaded', function () {
    var activeIndustry = getActiveIndustry();
    var query = getUrlParam('query');

    setupIndustryState(activeIndustry);
    setupDepartmentFiltersToggle();
    setupSearch();

    currentSearchQuery = query ? query.toLowerCase().trim() : '';
    if (currentSearchQuery) {
      var searchInput = document.getElementById('job-search-input') || document.getElementById('jobs-text-search-input');
      if (searchInput) {
        searchInput.value = currentSearchQuery;
      }
    }
    applyFilters();
  });
})();
